module.exports = __webpack_public_path__ + "img/grillentanz1.a09cd58d.jpg";